import * as React from 'react'

import DialogContent from '@mui/material/DialogContent'
import { Typography } from 'antd'

import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import DialogBox from './DialogBox'
import { useTranslation } from 'react-i18next'
import { Grid, Tooltip } from '@material-ui/core'
import Toast from '../../components/ToastContainer/CustomToast'
import { deleteMobileConfiguration } from '../../slices/MobileKeyConfiguration/MobileKeyConfigurationSlice'

export default function ResetKeyAssignmentDialog(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const { open, handleClose } = props
  

  const handleSubmit = () => {
    const payload = {
      id : props.customerId,
      customerName: props.customerName,
     numberOfDevices: props.numberOfDevices,
    }
    dispatch(deleteMobileConfiguration(payload))
      .unwrap()
      .then((data) => {
        handleClose(false)
        if (data.code === 'MSGS4074') {
          Toast(data.message, 'success')
          props.loadData()
        }
      })
      .catch((e) => { })
  }

  return (
    <>
      <DialogBox
        Header={
          <Typography variant="h6" style={{ fontWeight: "bold", fontSize: "1.25rem" }}>
            {t('RESET_KEY_ASSIGNMENT')}
          </Typography>
        }
        acceptText={t('CONFIRM')}
        cancelText={t('COMMON008')}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={'center'}
          style={{ padding: '20px' }}
        >
          <Grid>
            <Grid
              style={{
                wordWrap: 'break-word',
                opacity: 1,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
                fontSize: '17px',
                marginTop: '15px',
              }}
            >
              <DialogContent
                sx={{
                  textAlign: 'left',
                  fontSize: '18px',
                }}
              >
                <Typography style={{ marginBottom: '10px' }}>{t('RESET_KEY_OPERATION')}</Typography>
                <li>{t('RESET_KEY_OPERATION_TEXT1')}</li>
                <li>{t('RESET_KEY_OPERATION_TEXT2')}</li>
                <li>{t('RESET_KEY_OPERATION_TEXT3')}</li>
              </DialogContent>
            </Grid>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  )
}
